export const DOC_TYPE_ERROR_MESSAGE = "Please select document type";

export const MAX_FILE_NAME_LENGTH = 28;

enum DocType {
  Identity = "identity",
  Income = "income",
  PetOrAnimal = "pet_or_animal",
  Housing = "housing",
  Other = "other"
}

export const DocTypeLabelMap = {
  [DocType.Identity]: "Identity",
  [DocType.Income]: "Income",
  [DocType.PetOrAnimal]: "Pet or animal",
  [DocType.Housing]: "Housing",
  [DocType.Other]: "Other"
};

export const DocTypeOptions = [
  {
    label: "Identity",
    value: DocType.Identity
  },
  {
    label: "Income",
    value: DocType.Income
  },
  {
    label: "Pet or animal",
    value: DocType.PetOrAnimal
  },
  {
    label: "Housing",
    value: DocType.Housing
  },
  {
    label: "Other",
    value: DocType.Other
  }
];
